const MaskHelper = {
  cpfCnpj(cpfCnpj: string) {
    if (!cpfCnpj) {
      return cpfCnpj;
    }

    // CNPJ pode ser alfanumerico (IN RFB 2.229/2024); CPF nunca tem letra,
    // entao a presenca de letra so pode ser CNPJ.
    if (/[A-Za-z]/.test(cpfCnpj)) {
      return MaskHelper.cnpj(cpfCnpj);
    }

    let value = cpfCnpj.replace(/\D/g, "").slice(0, 14);

    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d)/, "$1.$2");
      value = value.replace(/(\d{3})(\d)/, "$1.$2");
      value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    } else {
      value = value.replace(/^(\d{2})(\d)/, "$1.$2");
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
      value = value.replace(/(\d{4})(\d)/, "$1-$2");
    }
    return value;
  },

  removeMask(data: string) {
    return data.replace(/\D/g, "");
  },

  cnpj(cnpj: string) {
    if (!cnpj) {
      return cnpj;
    }

    // Preserva letras (IN RFB 2.229/2024 - CNPJ alfanumerico); uppercase.
    let value = cnpj
      .replace(/[^0-9A-Za-z]/g, "")
      .toUpperCase()
      .slice(0, 14);
    value = value.replace(/^([0-9A-Z]{2})([0-9A-Z])/, "$1.$2");
    value = value.replace(
      /^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/,
      "$1.$2.$3"
    );
    value = value.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, ".$1/$2");
    value = value.replace(/([0-9A-Z]{4})([0-9A-Z])/, "$1-$2");
    return value;
  },

  cpf(cpf: string) {
    if (!cpf) {
      return cpf;
    }

    let value = cpf.replace(/\D/g, "").slice(0, 14);
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  },

  cep(cep: string) {
    if (!cep) {
      return cep;
    }
    return cep.replace(/(\d{5})(\d)/, "$1-$2");
  },

  phone(phone: string) {
    if (!phone) {
      return phone;
    }
    let value = phone.replace(/\D/g, ""); // Remove tudo o que não é dígito
    value = value.replace(/^(\d{2})(\d)/g, "($1) $2"); // Coloca parênteses em volta dos dois primeiros dígitos
    value = value.replace(/(\d)(\d{4})$/, "$1-$2"); // Coloca hífen entre o quarto e o quinto dígitos
    return value;
  },

  creditCardNumber(text: string) {
    if (!text) {
      return text;
    }
    const value = text.replace(/\D/g, "").slice(0, 16);
    return value.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
  },

  creditCardExpiration(text: string) {
    if (!text) {
      return text;
    }
    const numericValue = text.replace(/\D/g, "");
    if (numericValue.length > 2) {
      return `${numericValue.slice(0, 2)}/${numericValue.slice(2, 4)}`;
    }
    return numericValue;
  },

  creditCardCVC(text: string) {
    if (!text) {
      return text;
    }
    return text.replace(/\D/g, "").slice(0, 3);
  }
};

export default MaskHelper;
